import {useState} from 'react';
import './Home.css';
import { SliderData } from './SliderData';
import Hero from './Hero';
import SomeText from './SomeText';
import About from './About';
import HomeImage_Light from '../../images/bg-img.png';
import HomeImage_Dark from '../../images/bg-img2.png';
import { TypeAnimation } from 'react-type-animation';
import Logo from '../../images/logo_aliquam2.png';

const Home = () => {
  const [logo, setLogo] = useState(false)

  const changeLogo= () => {
      if(window.scrollY >= 95) {
          setLogo(true)
      }else{
          setLogo(false)
      }
  }

  window.addEventListener('scroll', changeLogo)

  return (
    <>
      <div className={logo ? 'img-container active' : 'img-container'}>
        <img src={Logo} className='logo3' alt="Logo" loading="lazy"/>
      </div>
      <div className='home-render'>
        <p>
        <TypeAnimation
          sequence={[
            "Passionate and Creative Minecraft Content Creators & Build Team!",
            2500,
            "Building Games with Love, Creativity & Soul - Professional Minecraft Creators!",
            2500,
            "Creative Minecraft Team - Developing Games with Originality!",
            2500,
            "Minecraft with Love - Professional Content and Building Projects!",
            2500,
            "Innovative Minecraft Projects - Created with Soul and Creativity!",
            2500,
          ]}
          cursor={true}
          speed={70}
          repeat={Infinity}
        />
        </p>
        <img src={HomeImage_Light} alt="Home_Image_Light" className='img_light'loading="lazy"/>
        <img src={HomeImage_Dark} alt="Home_Image_Dark" className='img_dark' loading="lazy"/>
      </div>
      <SomeText/>
      <Hero slides={SliderData}/>
      <About/>
    </>
  );
};

export default Home;
